module.exports = __webpack_public_path__ + "img/secondary-1.2971c23f.jpg";